import { instance } from '@/libs/api/instance'
import { v7 as uuidv7 } from 'uuid'

/**
 * Batch update beneficiaries sort order (pin/unpin).
 *
 * @param {Array<{uuid: string, sortOrder: number|null}>} items
 * @return {Promise<AxiosResponse<any>>}
 */
export const updateSortOrder = (items) => {
  return instance.patch(
    '/v1/beneficiary',
    {
      id: uuidv7(),
      items,
    },
    {
      params: { validate: 0 },
    },
  )
}
